/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Phone/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Heading from './Heading/index'
import NewPhone from './NewPhone/index'
import Phones from './Phones/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Phone({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Phone"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Phone.Vertical"
  data-view-path={viewPath}
 style={{'--mb-1-5yCzy': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-2-5yCzy': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Heading
  viewPath={`${viewPath}/Heading`}
/>
<Phones
  viewPath={`${viewPath}/Phones`}
/>
</div>
<NewPhone
  viewPath={`${viewPath}/NewPhone`}
/>
{children}
</React.Fragment>)
}